import { CSSObject } from "@emotion/react";
import { AngelouCSS, ComboboxStyleOverrides } from "@newsela/angelou";

export const schoolSelectorContainerStyle: CSSObject = {
  display: "flex",
  justifySelf: "flex-end",
};

export const schoolSelectorStyle: ComboboxStyleOverrides<AngelouCSS> = {
  root: {
    minWidth: "300px",
  },
};
